import { render, staticRenderFns } from "./BuilderEditFrame.vue?vue&type=template&id=55236f3d&scoped=true&"
import script from "./BuilderEditFrame.vue?vue&type=script&lang=js&"
export * from "./BuilderEditFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55236f3d",
  null
  
)

export default component.exports